import React from "react";
import {
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,

  Grid,
  Tooltip,
  Skeleton,
  Checkbox,
  IconButton,
  Pagination,
} from "@mui/material";
import {
  makeStyles
} from "@mui/styles";
import {
  Edit as EditIcon,
  Delete as DeleteIcon
} from "@mui/icons-material";
import {
  useStore
} from "react-redux";
import {
  Link
} from "react-router-dom"
import moment from "moment";

const TableCustom = (props) => {
  const {
    data,
    filter,
    totalPage,
    isLoad,
    onChange,
    onDelete
  } = props;

  const handleChangePage = (event, newPage) => {
    let newFilter = {...filter};
    newFilter.page = newPage;
    onChange(newFilter, true)
  }

  return (
    <>

      <Grid container justifyContent="flex-end" mb={2}>
        <Grid item><Pagination count={Number.parseFloat(totalPage || 0)} page={Number.parseFloat(filter.page || 0)} onChange={handleChangePage}/></Grid>
      </Grid>

      <Table>
        <TableHead>
          <TableRow>
            <TableCell>ID</TableCell>
            <TableCell>Наименование</TableCell>
            <TableCell>Артикул</TableCell>
            <TableCell>Скрыта</TableCell>
            <TableCell align="right">Обновлен</TableCell>
            <TableCell align="right">Создан</TableCell>
            <TableCell/>
          </TableRow>
        </TableHead>
        <TableBody>
          {Boolean(isLoad) && <RowLoading/>}
          {data.map((t) => <RowProducts key={`row-products-${t.id}`} product={t} onDelete={onDelete}/>)}
        </TableBody>
      </Table>

      <Grid container justifyContent="flex-end" mt={2}>
        <Grid item><Pagination count={Number.parseFloat(totalPage || 0)} page={Number.parseFloat(filter.page || 0)} onChange={handleChangePage}/></Grid>
      </Grid>

    </>
  )
}
const RowProducts = React.memo((props) => {
  const {
    product,
    onDelete
  } = props;
  const classes = useStyles();
  const currentLocale = useStore().getState()?.languages?.locale;

  const _getFiled = (translations, name) => {
    const translation = (translations || []).find((t) => t.locale === currentLocale);
    return translation?.[name]
  }

  return (
    <TableRow>
      <TableCell>
        {product.id}
      </TableCell>
      <TableCell>
        {_getFiled(product?.translations, 'name')}
      </TableCell>
      <TableCell>
        {product.code}
      </TableCell>
      <TableCell>
        <Checkbox checked={Boolean(product.is_hidden)}/>
      </TableCell>
      <TableCell align="right">Обновлен</TableCell>
      <TableCell align="right">Создан</TableCell>
      <TableCell>
        <Grid container spacing={1} justifyContent="flex-end">
          <Grid item>
            <Tooltip arrow title="Удалить">
              <IconButton color="error" onClick={onDelete.bind(this, product, false)}>
                <DeleteIcon/>
              </IconButton>
            </Tooltip>
          </Grid>
          <Grid item>
            <Tooltip arrow title="Редактировать">
              <IconButton color="info" component={Link} to={`/categories/${product.id}`}>
                <EditIcon/>
              </IconButton>
            </Tooltip>
          </Grid>
        </Grid>
      </TableCell>
    </TableRow>
  )
})
const RowLoading = React.memo(() => {
  return (<>
    {Array.apply(null, Array(10)).map((t) => (
      <TableRow key={`row-loading-${t}`}>
        <TableCell><Skeleton/></TableCell>
        <TableCell><Skeleton/></TableCell>
        <TableCell><Skeleton/></TableCell>
        <TableCell><Skeleton/></TableCell>
        <TableCell><Skeleton/></TableCell>
        <TableCell><Skeleton/></TableCell>
        <TableCell><Skeleton/></TableCell>
      </TableRow>
    ))}
  </>)
})

const useStyles = makeStyles(() => ({
  rowImage: {
    position: "relative",
    overflow: "hidden",
    maxWidth: 160,
    "& img": {
      position: "absolute",
      top: "50%", left: "50%",
      transform: "translate(-50%, -50%)",
      maxWidth: "100%",
      maxHeight: "100%"
    },
    "&:after": {
      content: "''",
      float: "left",
      paddingTop: "100%"
    }
  },
  rowLocale: {
    display: "flex",
    alignItems: "center",
    "& > *": {
      height: 32
    },
    "& img": {
      width: 24,
      height: 24
    },
    "& span": {
      fontSize: 16,
      lineHeight: "100%"
    },
  }
}));

export default React.memo(TableCustom)
